import localForage from 'localforage';
import _ from '@lodash';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'app/store';
import { type DevicesState, type DevicesActionTypes } from 'app/store/types';

const initialState: DevicesState = {};

const devicesReducer = (state = initialState, action: DevicesActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { devices },
			} = action.payload;

			if (devices && devices['ADXV013000009']) {
				console.log('DEBUG: Reducer received device data:', JSON.stringify(devices['ADXV013000009'], null, 2));
				console.log('DEBUG: Current state for device:', JSON.stringify(state[licenseGroupId]?.byId?.['ADXV013000009'], null, 2));
			}

			const newState = {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(devices && { byId: devices }),
				},
			};

			if (devices && devices['ADXV013000009']) {
				console.log('DEBUG: New state after update:', JSON.stringify(newState[licenseGroupId]?.byId?.['ADXV013000009'], null, 2));
			}

			return newState;
		}
		case 'SET_UNIV_PRINT_DEVICE_CODE_SUCCESS': {
			const {
				licenseGroupId,
				data: { UniversalPrintDeviceCode },
			} = action.payload;

			const newState = {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(UniversalPrintDeviceCode && {
						UniversalPrintDeviceCodeData: UniversalPrintDeviceCode,
					}),
				},
			};

			return newState;
		}
		case 'CLEAR_UNIV_PRINT_DEVICE_CODE': {
			const {
				licenseGroupId,
				data: { UniversalPrintDeviceCode },
			} = action.payload;

			const newState = {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					UniversalPrintDeviceCodeData: UniversalPrintDeviceCode,
				},
			};
			return newState;
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'devices',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	devicesReducer,
);

// Selectors
export const getDevicesByIdIncludingExternal = ({ app: { selectedLicenseGroupId }, devices }: RootState) =>
	devices[selectedLicenseGroupId].byId;

export const getDevicesById = createSelector([getDevicesByIdIncludingExternal], (devicesById) =>
	_.pickBy(devicesById, ({ variant }) => !(variant && variant.startsWith('external'))),
);

export const getUnivPrintDeviceCodeData = ({ app: { selectedLicenseGroupId }, devices }: RootState) =>
	devices[selectedLicenseGroupId].UniversalPrintDeviceCodeData;

export const getDevices = createSelector([getDevicesById], (devicesById) => Object.values(devicesById));

export const getDevicesIncludingExternal = createSelector([getDevicesByIdIncludingExternal], (devicesById) =>
	Object.values(devicesById),
);

export const getUnivPrintDeviceCodes = createSelector([getUnivPrintDeviceCodeData], (univPrintInfo) => univPrintInfo);
